import { REFI_MFE_UUID, RefiHttpClient } from '@cof/refi-web-sdk';
import { REFI_ESIGN_CONST } from '../../../../constants/app.constants.js';
import { SessionService } from '../session/session.service.js';
import { DebugService } from '../../../shared/services/debug.service.js';

class _ApiService {
  constructor() {
    this._client = new RefiHttpClient().withRetry(3);
    this.headers = { ...REFI_ESIGN_CONST.HTTP_HEADERS };
    if (REFI_ESIGN_CONST.isDevEnv) {
      this.headers['x-upstream-env'] = 'dev';
    } else if (REFI_ESIGN_CONST.isSBEnv) {
      this.headers['x-upstream-env'] = 'sb';
    }
    if (sessionStorage.getItem(REFI_ESIGN_CONST.C1_REFI_APPIDS)) {
      this.headers[REFI_ESIGN_CONST.C1_REFI_APPIDS] = sessionStorage.getItem(REFI_ESIGN_CONST.C1_REFI_APPIDS);
    }
    this.debug = new DebugService('ApiService');
  }

  buildHeaders(options = {}) {
    const id = REFI_MFE_UUID.makeUUID();
    let headers = {
      ...this.headers,
      'Client-Correlation-Id': id,
    };
    if (options?.headers) {
      headers = {
        ...headers,
        ...options.headers,
      };
      delete options.headers;
    }
    if (SessionService.session?.eAppId) {
      headers.eapp_id = SessionService.session.eAppId;
    }

    return headers;
  }

  async get(url, opts = {}) {
    const headers = this.buildHeaders(opts);
    return this._client
      .fetch(url, {
        headers,
        credentials: 'include',
        ...opts,
      })
      .then(this.constructor._httpInterceptor);
  }

  async post(url, body, opts = {}) {
    const headers = this.buildHeaders(opts);
    const options = {
      ...opts,
      headers,
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(body),
    };
    return this._client.fetch(url, options).then(this.constructor._httpInterceptor);
  }

  async put(url, body, opts = {}) {
    const headers = this.buildHeaders(opts);
    const options = {
      ...opts,
      headers,
      credentials: 'include',
      method: 'PUT',
      body: JSON.stringify(body),
    };
    return this._client.fetch(url, options).then(this.constructor._httpInterceptor);
  }

  static _httpInterceptor(res) {
    if (res.status === 204) {
      return res;
    }
    if (res.status >= 200 && res.status < 300) {
      return res.json();
    }
    if (res.status === 403) {
      document.dispatchEvent(new CustomEvent('refi-login-sign-out'));
    }
    if (res.status === 401) {
      document.dispatchEvent(new CustomEvent('refi-login-sign-out'));
    }
    return Promise.reject(res);
  }
}

export const ApiService = new _ApiService();
